'use strict';

const $ = require('jquery');
require('waypoints/lib/noframework.waypoints.min.js');

const SELECTORS = {
    NAV: '.production-nav',
    BUTTON: '.production-nav__item',
};

const CLASSES = {
    BUTTON_ACTIVE: 'production-nav__item--active',
};

function init() {
    let $container = $(SELECTORS.NAV);

    if (!$container.length) {
        return false;
    }

    (function () {
        new Waypoint({
          element: document.getElementById('trigger'),
          handler: function(direction) {
            if (direction === 'down') {
                document.getElementById('nav').classList.add('is-sticky');
            } else {
                document.getElementById('nav').classList.remove('is-sticky');
            }
          }
        })
    })();

    $(document).on('scroll', () => {
        let scrollPos = $(document).scrollTop() + $container.height();

        $(SELECTORS.BUTTON).each(function () {
            let $this = $(this);
            let $target = $($this.data('target'));
            let targetTop = $target.position().top;

            if (targetTop <= scrollPos && targetTop + $target.height() > scrollPos) {
                $(SELECTORS.BUTTON).removeClass(CLASSES.BUTTON_ACTIVE);
                $this.addClass(CLASSES.BUTTON_ACTIVE);
            } else {
                $this.removeClass(CLASSES.BUTTON_ACTIVE);
            }
        });
    });
}

module.exports = {
    init: init
};
